<template>
	<div v-if="isConditionMet" @click="$emit('click', $event)" :style="`width: 100%; padding-top: ${item.pt || 0}px; padding-bottom: ${item.pb || 0}px!important`">
		<pdf-embed v-if="item.url" :url="item.url" :file-name="item.fileName" :interactive="!builder" :class="`form-pdf align-${item.alignment || 'center'}`" :style="`width: ${item.scale || 100}%`"></pdf-embed>
		<div v-else><v-icon class="material-symbols-outlined" size="100">picture_as_pdf</v-icon></div>
	</div>
</template>

<script>
	// Form PdfBlock. Links in the PDF stay clickable; in the builder the link
	// layer is hidden so clicks select the element.
	import RendererMixin from '@/modules/forms/v2/schema/RendererMixin';
	import PdfEmbed from '@/modules/forms/v2/schema/PdfEmbed';

	export default {
		name: 'PdfBlock',

		props: ['item', 'results', 'builder'],

		mixins: [RendererMixin],

		components: { PdfEmbed },
	};
</script>

<style scoped lang="scss">
	.form-pdf {
		max-width: 100%;
		margin: 0 auto;

		&.align-left { margin-left: 0; }
		&.align-right { margin-right: 0; }
	}
</style>
